/**
 * Customized Toast component.
 *
 * Reference: https://chakra-ui.com/docs/theming/customize-theme
 * Figma Reference: https://www.figma.com/file/Z8kfGR6BNKMm3XvQGhKcBD/PINS-Advantage-2021-Design-System?node-id=5%3A3
 */
import colors from '../foundation/colors';

const Toast = {
  baseStyle: {
    color: 'white',
    fontSize: 'md',
    fontWeight: 'medium',
    lineHeight: '24px',
    textAlign: 'center',
    borderRadius: '4xl',
    textTransform: 'capitalize'
  },
  variants: {
    info: {
      bg: colors.gradient.primary
    },
    general: {
      bg: colors.gradient.general
    },
    success: {
      bg: colors.gradient.success
    },
    error: {
      bg: colors.gradient.error
    },
    warning: {
      bg: colors.gradient.warning
    },
    secondary: {
      bg: colors.gradient.secondary
    }
  },
  sizes: {
    md: { minH: '40px', height: 'auto', minW: '375px' },
    lg: { minH: '48px', height: 'auto', minW: '375px', width: 'auto' }
  },
  defaultProps: {
    size: 'lg',
    variant: 'default'
  }
};

export default Toast;
